var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEthBrand = function SvgEthBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#eth-brand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 9 .121.41v11.902l-.12.12-5.498-3.265z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.002 9 5.498 9.167-5.498 3.266V9M18.003 22.475l.067.083v4.24l-.067.198-5.502-7.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.002 26.996v-4.521L23.5 19.21zM18 21.433l-5.498-3.266L18 15.657zM23.5 18.167l-5.498 3.266v-5.777z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eth-brand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5 9h-11v18h11z"
  })))));
};
export default SvgEthBrand;